<agr-page-toolbar
  [hasPrimaryAction]="quickSimulationsCanbeCalculated"
  primaryActionIcon="add"
  [primaryActionText]="'feed-profit.detail.quick-simulation.add-simulation' | translate"
  (primaryAction)="addQuickSimulation()"
  [hasSecondaryAction]="quickSimulationsCanbeCalculated"
  secondaryActionIcon="print"
  [secondaryActionText]="'feed-profit.detail.quick-simulation.print' | translate"
  (secondaryAction)="printQuickSimulations()"
  data-test="quick-simulation"
>
</agr-page-toolbar>
<div class="notification-status-message" data-test="notification-status-message">
  <div *ngIf="!quickSimulationsCanbeCalculated" class="spacing--margin-all">
    <agr-extended-notification
      notificationType="info"
      [title]="'feed-profit.detail.quick-simulation.cant-calculate.title' | translate"
      [message]="'feed-profit.detail.quick-simulation.cant-calculate.description' | translate"
    >
    </agr-extended-notification>
  </div>
</div>
<b>{{ 'feed-profit.detail.quick-simulation.title' | translate }}</b>
<p>{{ 'feed-profit.detail.quick-simulation.description' | translate }}</p>
<ng-container *ngIf="tableConfig$ | async as tableConfig">
  <agr-table
    *ngIf="(isLoading$ | async) === false"
    [emptyTitle]="'feed-profit.detail.quick-simulation.no-calculations.title' | translate"
    [emptyDescription]="
      'feed-profit.detail.quick-simulation.no-calculations.description' | translate
    "
    emptyImage="assets/images/pigs_001.jpg"
    [config]="tableConfig$ | async"
    class="table screen-only"
  ></agr-table>
</ng-container>
<ng-template #fullWidthRow let-row="row">
  <div *ngIf="row.text">
    <b>
      {{ row.text }}
    </b>
  </div>
</ng-template>
<ng-template #dataColumn let-row="row" let-column="column" let-i="index">
  <div class="differenceColumn">
    <span class="text--body valueText">
      {{ getValue(row[column.id], column.digitsInfo) }}
    </span>
    <span
      *ngIf="isPositive(getDifferenceValue(row, column)) > 0"
      class="text-color--primary-500 text--small"
    >
      +
    </span>
    <span
      *ngIf="!row.isComparisonSim"
      class="text--small"
      [ngClass]="
        isPositive(getDifferenceValue(row, column)) > 0
          ? 'text-color--primary-500'
          : isPositive(getDifferenceValue(row, column)) < 0
            ? 'text-color--warn-500'
            : ''
      "
    >
      {{ getDifferenceValue(row, column, column.digitsInfo) }}
    </span>
    <mat-icon
      *ngIf="isPositive(getDifferenceValue(row, column)) > 0"
      class="text-color--primary-500 text--small"
      >arrow_upward</mat-icon
    >
    <mat-icon
      *ngIf="isPositive(getDifferenceValue(row, column)) < 0"
      class="text-color--warn-500 text--small"
      >arrow_downward</mat-icon
    >
  </div>
</ng-template>
<ng-template #deleteColumn let-row="row" let-column="column">
  <div *ngIf="!row.isComparisonSim">
    <button
      mat-icon-button
      data-test="feed-profit-quicksimulation-deletion-button"
      class="deletionColumn"
      (click)="this.deleteFeedProfitSimulation(row.id)"
    >
      <mat-icon>delete</mat-icon>
    </button>
  </div>
</ng-template>

<agr-print-page
  class="print-only"
  [footerText]="'feed-profit.detail.quick-simulation.description' | translate"
  orientation="landscape"
  [customizedLogoSrc]="
    (location$ | async)?.country === 'NL' ? '/assets/images/thinkpig_50.png' : null
  "
>
  <app-quick-simulation-report
    [rows]="calculationsDatasource$ | async"
  ></app-quick-simulation-report>
</agr-print-page>
